import { useEffect } from "react";
import { ShippingDetailsViewModelV2 } from "../../viewmodels/shipping/ShippingDetailsViewModelV2";

import { useParams } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";
import ShippingFormV2 from "../../components/forms/shipping/ShippingFormV2";
import ShipmentReportButton from "../../components/shippingReports/ShipmentReportButton";

function ShippingDetailsV2(props) {
  const { addSnackbar, logout } = props;

  const { shippingId } = useParams();

  const {
    onFetchOrderItems,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    emptyModal,
    showErrorModal,
    updateShippingApiCall,
    shipping,
    onFetchPackagedItemByBarcode,
    addPackagedItemToOrderItem,
    getShippingDetails,
    runInitialLoad,
    loading,
    deleteShippingItemApiCall,
    addSkidLabelToOrderItem,
    employeeOptions,
    getEmployeesForDropdown,
    deleteShipping,
    printShipping,
    quickAddPackagedItemToOrderItem,
    deleteQuickScanShippingItemByLot,
    exportOrderForNetSuite,
    getOrderItemsOnly,
    rowDetails,
    setRowDetails,
    fetchRowDetails,
    loadingRows,
    sunCustomers,
    getSunCustomersForDropdown,
    sendShippingToQuickbooks,
    createSolmazInvoice,
    quickBooksStatus,
    quickBooksEnqueueing,
    sunQuickBooksStatus,
    sunQuickBooksEnqueueing,
    openSunShippingLabelReview,
    printShippingLabel,
    calculateFreightWeight,
    generateBolDocument,
    generateBolNumber,
    updateOrderItemUnitPrice,
    checkForExpiredItems,
  } = ShippingDetailsViewModelV2(shippingId, logout, addSnackbar);

  useEffect(() => {
    runInitialLoad();
    // ViewModel actions are render-scoped; reload on route identity, not every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shippingId]);

  const shipmentCustomerLabel =
    typeof shipping?.customer === "string"
      ? shipping.customer
      : shipping?.customer?.label ||
        shipping?.customer?.name ||
        shipping?.sun_customer?.label ||
        shipping?.sun_customer?.name ||
        shipping?.order?.label ||
        "Shipment details";

  return (
    <div>
      <div className="mt-2 pl-0 sm:px-4">
        {shipping ? (
          <div className="mb-4 flex flex-col justify-between gap-3 rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:flex-row sm:items-center">
            <div>
              <h1 className="text-xl font-semibold text-slate-900">
                Shipment #{shipping.id}
              </h1>
              <p className="mt-1 text-sm text-slate-500">
                {shipmentCustomerLabel}
              </p>
            </div>
            <ShipmentReportButton
              parentType="shipping"
              parentId={shipping.id}
              logout={logout}
              addSnackbar={addSnackbar}
            />
          </div>
        ) : null}
        {loading ? (
          <div className="text-sm text-gray-500 py-8">Loading shipment…</div>
        ) : shipping ? (
          <ShippingFormV2
            orders={[]}
            onFetchOrderItems={onFetchOrderItems}
            isEdit={true}
            setEmptyModelOpen={setEmptyModelOpen}
            showErrorModal={showErrorModal}
            updateShippingApiCall={updateShippingApiCall}
            shipping={shipping}
            onFetchPackagedItemByBarcode={onFetchPackagedItemByBarcode}
            addPackagedItemToOrderItem={addPackagedItemToOrderItem}
            deleteShippingItemApiCall={deleteShippingItemApiCall}
            addSkidLabelToOrderItem={addSkidLabelToOrderItem}
            employeeOptions={employeeOptions}
            deleteShipping={deleteShipping}
            printShipping={printShipping}
            quickAddPackagedItemToOrderItem={quickAddPackagedItemToOrderItem}
            deleteQuickScanShippingItemByLot={deleteQuickScanShippingItemByLot}
            exportOrderForNetSuite={exportOrderForNetSuite}
            getOrderItemsOnly={getOrderItemsOnly}
            rowDetails={rowDetails}
            setRowDetails={setRowDetails}
            fetchRowDetails={fetchRowDetails}
            loadingRows={loadingRows}
            sunCustomers={sunCustomers}
            sendShippingToQuickbooks={sendShippingToQuickbooks}
            createSolmazInvoice={createSolmazInvoice}
            quickBooksStatus={quickBooksStatus}
            quickBooksEnqueueing={quickBooksEnqueueing}
            sunQuickBooksStatus={sunQuickBooksStatus}
            sunQuickBooksEnqueueing={sunQuickBooksEnqueueing}
            openSunShippingLabelReview={openSunShippingLabelReview}
            printShippingLabel={printShippingLabel}
            calculateFreightWeight={calculateFreightWeight}
            generateBolDocument={generateBolDocument}
            generateBolNumber={generateBolNumber}
            updateOrderItemUnitPrice={updateOrderItemUnitPrice}
            checkForExpiredItems={checkForExpiredItems}
          />
        ) : null}
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass={slideOver.customClass ?? "max-w-3xl"}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShippingDetailsV2),
);
